import { render, staticRenderFns } from "./entity-details-provider.vue?vue&type=template&id=6658813c&scoped=true&"
import script from "./entity-details-provider.ts?vue&type=script&lang=ts&"
export * from "./entity-details-provider.ts?vue&type=script&lang=ts&"
import style0 from "./entity-details-provider.scss?vue&type=style&index=0&id=6658813c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658813c",
  null
  
)

export default component.exports